/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".white-listing-cls[_ngcontent-%COMP%]{margin:5px 10px auto!important}"];
export { styles as styles };
